var render, staticRenderFns
import script from "./associated_customer_three.vue?vue&type=script&lang=js"
export * from "./associated_customer_three.vue?vue&type=script&lang=js"
import style0 from "./associated_customer_three.vue?vue&type=style&index=0&id=9a54f78e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a54f78e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a54f78e')) {
      api.createRecord('9a54f78e', component.options)
    } else {
      api.reload('9a54f78e', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/user_client_management/form/associated_customer/associated_customer_three.vue"
export default component.exports